import React from 'react';
import { Result } from 'antd';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { Link } from '@/intl/navigation';

type Props = {
  icon: React.ReactNode;
  subTitle: string;
  extraHref: string;
  extraText: string;
};

function PasswordResetNotification({
  icon,
  subTitle,
  extraHref,
  extraText,
}: Props) {
  const auth = useTranslations('auth');
  return (
    <AnimatePresence>
      <div className="mx-auto mb-10 mt-20 flex  w-3/4  rounded-2xl  bg-white py-10 md:mt-5">
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -100, opacity: 0 }}
        >
          <Result
            icon={icon}
            status={'success'}
            title={
              <div className="mb-5 text-lg font-extrabold text-primary-dark sm:text-xl md:mb-10 md:text-2xl">
                {auth('forms.apiResponse.successful')}
              </div>
            }
            subTitle={<div className="mx-auto my-3">{subTitle}</div>}
            extra={[
              <Link
                key={1}
                className="hover:text-secondary-dark text-center text-lg font-bold text-secondary underline "
                href={extraHref}
              >
                {extraText}
              </Link>,
            ]}
          />
        </motion.div>
      </div>
    </AnimatePresence>
  );
}

export default PasswordResetNotification;
